webClient.controller('AirPaymentResponseOK', ['$scope', '$window', '$timeout', '$filter', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', 'trackingService', 'gtmProduct', 'gtmModel', 'omnitureService',
    function ($scope, $window, $timeout, $filter, tseApiClient, tseUtil, airHelper, trackingService, gtmProduct, gtmModel, omnitureService) {
        $scope.getText = function (key) { return window.culture.texts[key]; };
        $scope.apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);
        var searchUrl = "/";
        var bkgData;
        $scope.bkDataMock = tseUtil.Session.get('bkDataMock');

        if (!$scope.bkDataMock) {

            searchUrl = $window.site.currentAirRequest.searchUrl + "?" + tseUtil.Location.getQueryString();
            bkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);
            if (bkgData) {

                var keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
                bkgData.bookingRequest = tseUtil.Session.get("bookingRequest_" + keyGenerated);
                var _insuranceSelected = tseUtil.Session.get("insurancesSelected_" + keyGenerated);
                bkgData.banqueCasinoSchedule = tseUtil.Session.get("banqueCasino" + keyGenerated);
            }
        } else {
            bkgData = $scope.bkDataMock.value;
            var keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
            var _insuranceSelected = tseUtil.Session.get("insurancesSelected_" + keyGenerated);
        }

        tseUtil.Session.set('paxHistory', {});
        $scope.bkgData = bkgData;
        $window.$scope = $scope;
        $scope.siteType = $window.site.type;
        window.hideMessageTO = true;
        window.displayBrandedFaresSummary = true;
        $scope.enableUpSellProducts = $window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true';
        $scope.enablePostBookingInsurance = $window.enablePostBookingInsurance;

        $scope.enableMtrip = $window.enableMtrip;
        
        //don't show cross sell when an hotel is already booked
        $scope.hideCrossSell = typeof $scope.bkgData.accommodations !== 'undefined' && $scope.bkgData.accommodations != null && $scope.bkgData.accommodations.any();

        //Tracking
        try {
            //GTM
            if (trackingService.isActivated()) {
                trackingService.initDataLayer('purchase');
                if (trackingService.loadSessionData('step', 4) != null) { //can be null for few WL sites
                    trackingService.loadSessionData('step', 4).convertToPurchase($scope.bkgData.bookingResponse);
                }
                trackingService.parseScope($scope);
                trackingService.pushDataLayer(null, null);
            }
            //omniture
            if (omnitureService.isActivated()) {
                omnitureService.sendEvent(omnitureService.FLIGHT_CONFIRMATION, omnitureService.CONFIRMATION, null);
            }
        }
        catch (ex) {
            console.log(ex.message);
            $window.trackingError = ex.message;
        }

        if (bkgData) {
            $scope.numbers = bkgData.bookingResponse.numbers;
            $scope.bookingId = bkgData.bookingResponse.bookingId;
            $scope.agentEmail = null;

            $scope.myBookingsLink = '/reservation/details?reference=' + $filter('bookingNumber')($scope.numbers[0].bookingNumber) + '&email=' + bkgData.bookingRequest.contact.mail + '#i-booking-details-insurances';
            $scope.noInsuranceSelected = angular.equals({}, bkgData.insurancesSelected);
            $scope.todayDeparture = moment().format("YYYY/MM/DD") === moment(bkgData.request.itineraries[0].goDate).format("YYYY/MM/DD");

            
            if ($window.site.loginInfo && $window.site.loginInfo.Agent)
                $scope.agentEmail = $window.site.loginInfo.Agent.Account;

            if ($window.site.loginInfo && $window.site.loginInfo.Client)
                $scope.clientPaymentMode = $window.site.loginInfo.Client.PaymentMode;


            if (bkgData.bookingRequest != null && bkgData.bookingRequest.requestId == bkgData.request.requestId) {

                window.sendDoubleClickConfirm("confvol", bkgData.purchaseResponse.itineraries[0].origin.airportIata, bkgData.purchaseResponse.itineraries[0].destination.airportIata, bkgData.bookingRequest.passengers.length, bkgData.prixTotal.value);
                window.sendDoubleClickConfirm("confpvfr", bkgData.purchaseResponse.itineraries[0].origin.airportIata, bkgData.purchaseResponse.itineraries[0].destination.airportIata, bkgData.bookingRequest.passengers.length, bkgData.prixTotal.value);

                bkgData.insurancesSelected = _insuranceSelected;

                if (bkgData.banqueCasinoSchedule != undefined)
                    bkgData.banqueCasino = true;

                if ($scope.bkgData.bookingRequest.paymentMethod.isOption)
                    $scope.bkgData.bookingRequest.paymentMode = 4;

                $scope.paymentMode = $scope.bkgData.bookingRequest.paymentMode;

                $scope.$broadcast("onBookingSummaryUpdate");
            }
            else {
                $window.FLoading({ vAction: 'show' });
                $window.location.href = searchUrl;
            }

            var totalTax = 0;
            for (var i = 0; i < bkgData.purchaseResponse.proposalsRequested.fares.length; i++) {
                var fare = bkgData.purchaseResponse.proposalsRequested.fares[i];
                totalTax += fare.totalTax.value;
            }

            var fareWithOutTaxes = bkgData.purchaseResponse.proposalsRequested.totalAmount.value - totalTax;
            $window.fareWithOutTaxes = fareWithOutTaxes;

            if ($window.enableVPTracking) {
                $window.VPTracking();
            }

            $(document).trigger('bkgdata-loaded');

            $window.sendGoogleTrans(bkgData.bookingResponse.bookingNumber, bkgData.prixTotal.value, $scope.bkgData.purchaseResponse.itineraries[0].destination.airportIata);
            $window.sendGoogleConversion(bkgData.prixTotal.value);
        }
        else {
            $window.FLoading({ vAction: 'show' });
            $window.location.href = searchUrl;
        }

        //Taxes details click
        $scope.$on("displayTaxesDetailsClick", function (event, args) {
            $scope.displayTaxesDetailModal = true;
            $scope.modalTaxesKey = args.key.replaceAll(":", "-");
            $scope.modalTaxesKey = $scope.modalTaxesKey.replaceAll("\\|", "-");
            $scope.modalTaxesKeyAux = $scope.modalTaxesKey + "-" + args.paxFares.paxType;
            $scope.modalTaxesPaxType = args.paxType;
            $scope.modalTaxesPaxFares = args.paxFares;
            $scope.modalPaxNumber = args.paxNumber;

            $scope.modalShowMargin = false;

            var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

            args.marketingCarriers.each(function (value, key) {

                if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                    $scope.modalShowMargin = true;
                }
            });

            $scope.$broadcast("updateTaxesDetailModalData", { key: $scope.modalTaxesKey, paxType: $scope.modalTaxesPaxType, fares: $scope.modalTaxesPaxFares, paxnumber: $scope.modalPaxNumber });

            //Remodal workaround
            $(document).find(".remodal").each(function (a, c) {
                var d = $(c), e = d.data("remodal-options");
                e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                    d["remodal"](e)
            });

            $timeout(function () {
                $('[data-remodal-id=' + 'taxes-detail-modal-' + $scope.modalTaxesKeyAux + ']').remodal().open();
            }, 200, false);

        });

        //Luaggage details click
        $scope.$on("displayLuggageDetailsClick", function (event, args) {
            $scope.displayLuggageDetailModal = true;
            $scope.modalLuggageBagType = args.bagType;

            $scope.$broadcast("updateLuggageDetailModalData", { bagType: $scope.modalLuggageBagType });

            $scope.modalShowMargin = false;

            var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

            args.marketingCarriers.each(function (value, key) {

                if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                    $scope.modalShowMargin = true;
                }
            });

            //Remodal workaround
            $(document).find(".remodal").each(function (a, c) {
                var d = $(c), e = d.data("remodal-options");
                e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                    d["remodal"](e)
            });

            $timeout(function () {
                $('[data-remodal-id="luggage-detail-modal"]').remodal().open();
            }, 200, false);
        });

        //don't show cros sell when we already have an hotel
        if ($scope.hideCrossSell === false) {
            //hotel cross sell load data
            console.log("hotel cross sell load data!!!");
            var airport = $scope.bkgData.purchaseResponse.itineraries[0].destination.airportIata;
            var fromDate = moment($scope.bkgData.purchaseResponse.itineraries[0].arrivalDateTime).format("YYYY-MM-DD");
            var toDate = null;
            if ($scope.bkgData.purchaseResponse.itineraries[1]) {
                toDate = moment($scope.bkgData.purchaseResponse.itineraries[1].departureDateTime).format("YYYY-MM-DD");
            }
            else {
                toDate = moment(fromDate).add(1, 'days').format("YYYY-MM-DD");
            }
            var nbPaxes = bkgData.request.totalPaxes;
            var arPax = [];
            for (i = 0; i < nbPaxes; i++) {
                var age = Math.floor(moment(new Date()).diff(moment(bkgData.bookingRequest.passengers[i].birthDate, "DD/MM/YYYY"), 'years', true));
                if (age < 17) arPax[i] = { "type": "CHILD", "age": age, "birthDate": moment(bkgData.bookingRequest.passengers[i].birthDate, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD'), "lastName": bkgData.bookingRequest.passengers[i].lastName, "firstName": bkgData.bookingRequest.passengers[i].firstName };
                else arPax[i] = { "type": "ADULT", "age": age, "birthDate": moment(bkgData.bookingRequest.passengers[i].birthDate, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD'), "lastName": bkgData.bookingRequest.passengers[i].lastName, "firstName": bkgData.bookingRequest.passengers[i].firstName };
            }


            var crossSellInterval = setInterval(function () {

                window.hotelXSellParam = {
                    "destination": {
                        "type": "airport",
                        "value": airport
                    },
                    "date": {
                        "from": fromDate,
                        "to": toDate
                    },
                    "nbPax": nbPaxes,
                    "pax": arPax
                };

                if (typeof crossSellController !== "undefined") {
                    if ($('#crossSellDiv').length == 0) {
                        crossSellController.fetchSearchFormContent();
                    }
                    else {
                        clearInterval(crossSellInterval);
                    }
                }
            }, 500);
        }
        else {
            if ($('#crossSellDiv').length === 0) {
                $('#crossSellDiv').remove();
            }
        }
        $.getScript("/global/js/widgets/mrfly-widget-mtrip.js").done(function () {
            if (mrflyWidgets["mrfly-widget-mtrip"] !== undefined) {
                mrflyWidgets["mrfly-widget-mtrip"].$refs.instance.bookingnumber = $scope.bkgData.bookingResponse.numbers[0].bookingNumber;
            }
        });
    }
]);